import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { BookingWindowCancelledContainer } = await import('@containers/Payment/ErrorScreens/BookingWindowCancelled');
    return {
        Component: BookingWindowCancelledContainer,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
